import React, { useState, useEffect, useMemo } from 'react';
import styles from './login.module.less';
import { Input, Button, Form } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { verifyResetPasswordWithOtp } from '@Modules/account/profile/ProfileActions';
import { useDispatch, useSelector } from 'react-redux';
import { passwordValidation } from '@Utils/PasswordValidation';
import { resendOTPCodeFetch } from '@Modules/account/auth/AuthActions';
import { useCounter } from '../../../hook/useCounter';
import qs from 'qs';
import { history } from '@Redux/store';
import { detectFlavor } from '@Utils/FlavorUtils';

const ResetPasswordVerification = () => {
  const dispatch = useDispatch();

  const { search } = useLocation();

  const { email, otpId } = useMemo(() => {
    return qs.parse(search, { ignoreQueryPrefix: true });
  }, [search]);

  const [newPassword, setNewPassword] = useState('');

  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  const [code, setCode] = useState('');

  const [isDisabled, setIsDisabled] = useState(true);

  const { resetPasswordLoading } = useSelector(
    (state) => state.account.profile
  );

  useEffect(() => {
    const disabled =
      !code ||
      !newPassword ||
      !confirmNewPassword ||
      !checkPasswordsMatch() ||
      passwordValidation(newPassword) !== null;

    setIsDisabled(disabled);
  }, [code, newPassword, confirmNewPassword]);

  const checkPasswordsMatch = () => {
    if (confirmNewPassword === '') return true;
    if (newPassword === confirmNewPassword) return true;
    return false;
  };

  const handleResendOtpBtn = () => {
    if (otpId) {
      dispatch(resendOTPCodeFetch(otpId));
    }
  };

  const { isCounting, timer, reset } = useCounter({
    duration: 180,
    immediate: true,
    onReset: handleResendOtpBtn,
  });

  const handleVerifyOtpCode = () => {
    dispatch(
      verifyResetPasswordWithOtp({
        body: {
          userEmail: email,
          newPassword: newPassword,
          otpCode: code,
          otpId: otpId,
        },
        cb: () => history.push('/auth/login'),
      })
    );
  };

  const flavor = detectFlavor();

  return (
    <div className={styles[`home-page-${flavor}`]}>
      <div className={styles[`home-page__box-${flavor}`]}>
        <div
          className={`${styles['home-page__left-section']} ${
            styles[`home-page__left-section-${flavor}`]
          }`}
        >
          <div className={styles.form}>
            <div
              className={styles.form__back_button}
              onClick={() => {
                const params = qs.stringify(
                  { email },
                  { addQueryPrefix: true, encode: false }
                );

                history.push('/auth/reset-password' + params);
              }}
            >
              <ArrowLeftOutlined />
              <span style={{ marginLeft: '8px' }}>Back</span>
            </div>
            <div className={styles.form__header}>
              Reset Password Verification
            </div>
            <div className={styles.form__caption}>
              {`Enter the verification code sent to your email: (${email})`}
            </div>
            <div className={styles['form__item--last']}>
              <div className={styles.form__title}>Verification Code</div>
              <Input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                className={styles.form__input}
                autoComplete="off"
              />
            </div>
            <div className={styles.timer}>
              <span
                className={
                  isCounting
                    ? styles.disabled_resend__button
                    : styles.enabled_resend__button
                }
                onClick={isCounting ? () => {} : reset}
              >
                Resend
              </span>
              {isCounting && (
                <span className={styles.timer}>{`(${timer})`}</span>
              )}
            </div>
            <div className={styles['form__item--last']}>
              <div className={styles.form__title}>New Password</div>
              <Form.Item
                validateStatus={
                  passwordValidation(newPassword) ? 'error' : null
                }
                help={passwordValidation(newPassword)}
              >
                <Input.Password
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className={styles.form__input}
                  autoComplete="off"
                />
              </Form.Item>
            </div>
            <div className={styles['form__item--last']}>
              <div className={styles.form__title}>Repeat New Password</div>
              <Form.Item
                validateStatus={checkPasswordsMatch() ? null : 'error'}
                help={
                  checkPasswordsMatch() ? null : 'Your password is not match'
                }
              >
                <Input.Password
                  value={confirmNewPassword}
                  onChange={(e) => setConfirmNewPassword(e.target.value)}
                  className={styles.form__input}
                />
              </Form.Item>
            </div>
            <div className={styles['form__button-container']}>
              <Button
                loading={resetPasswordLoading}
                onClick={handleVerifyOtpCode}
                type="primary"
                className={styles.form__login}
                disabled={isDisabled}
                shape="round"
                lassName={styles.form__login}
              >
                Change Password
              </Button>
            </div>
          </div>
        </div>
        <div
          id={`reset-side-${flavor}`}
          className={styles[`home-page__right-section-${flavor}`]}
        />
      </div>
    </div>
  );
};

export { ResetPasswordVerification };
